import { common } from './common';
import { home } from './home';
import { portal } from './portal';
import { guide } from './guide';

const en = { common, home, portal, guide };

export default en;
